import controller from './plannedPublish.timePickers.controller'
import template from './plannedPublish.timePickers.template.html'

export default {
  restrict: 'E',
  replace: true,
  require: {
    ngModel: '^ngModel',
  },
  template,
  controller,
  controllerAs: 'vm',
}
